export const ANONYMOUS = "ANONYMOUS"
export const INVALID_INVESTIGATOR = "Invalid Investigator"
export const SERVICE_ERROR = "Service returned and error. Please try again."